// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box } from '@material-ui/core';
import { GridOverlay, GridToolbar } from '@material-ui/data-grid';
import { DataTable, EmptyState } from '../../../../common/components';
import { DateUtils } from '../../../../common/utils';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    '& .MuiDataGrid-root': {
      border: '0',
    },
  },
}));

function AccessLogsTab(props) {
  const [t] = useTranslation();
  const classes = useStyles();

  const { data } = props;

  const getColumnDefs = () => [
    {
      field: 'logtime',
      headerName: t('accessLog.accessLogTime'),
      width: 200,
      type: 'dateTime',
      valueFormatter: params => DateUtils.getDateTime(params.value),
    },
    {
      field: 'ip',
      headerName: t('accessLog.accessLogIp'),
      width: 200,
    },
    {
      field: 'access',
      headerName: t('accessLog.accessLogAccess'),
      width: 250,
    },
    {
      field: 'details',
      headerName: t('accessLog.accessLogDetails'),
      width: 300,
      flex: 1,
    },
    {
      field: 'usrAgent',
      headerName: t('accessLog.accessLogUsrAgent'),
      width: 250,
    },
    {
      field: 'city',
      headerName: t('accessLog.accessLogCity'),
      width: 200,
    },
    {
      field: 'suspicious',
      headerName: t('accessLog.accessLogSuspicious'),
      width: 200,
      filterable: false,
      valueFormatter: params => (params.value ? t('common.yes') : t('common.no')),
    },
  ];

  const getRowData = () =>
    data.map((accessLog, index) => ({
      ...accessLog,
      id: index,
    }));

  const renderNoRowsOverlay = () => (
    <GridOverlay>
      <EmptyState variant="empty" message={t('accessLog.accessLogsEmpty')} />
    </GridOverlay>
  );

  return (
    <Box id="AccessLogsTab-container" className={classes.container}>
      <DataTable
        id="AccessLogsTab-table"
        components={{
          Toolbar: GridToolbar,
          NoRowsOverlay: renderNoRowsOverlay,
        }}
        columns={getColumnDefs()}
        rows={getRowData()}
        pageSize={20}
        paginationMode="client"
        pagination
      />
    </Box>
  );
}

AccessLogsTab.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default AccessLogsTab;
